import React, { memo } from 'react';
import classnames from 'classnames';

import { Button, Icon, Text, useTheme } from '@Sage/hoi-poi-ui';

import RatesSectionBlock from './RatesSectionBlock';

const RatesTableSection = memo(
    ({
        addLabel,
        children,
        className,
        count = 0,
        emptyText,
        footer,
        isEmpty,
        onAdd,
        sectionAdvice,
        sectionExtraText,
        sectionSubtitle,
        sectionTitle,
        widgetTitle,
    }) => {
        const theme = useTheme();

        return (
            <div className={classnames('rates-crud-lines-widget', className)}>
                <RatesSectionBlock
                    advice={sectionAdvice}
                    extraText={sectionExtraText}
                    subtitle={sectionSubtitle}
                    title={sectionTitle}
                />
                <div className="rates-crud-lines-widget__card">
                    <div className="rates-crud-lines-widget__header">
                        <div className="rates-crud-lines-widget__header-title">
                            <Text type="subtitle1" medium>
                                {widgetTitle}
                            </Text>
                            <Text
                                className="rates-crud-lines-widget__header-counter"
                                color={theme.colors.utility.textSecondary}
                                type="caption"
                            >
                                ({count})
                            </Text>
                        </div>
                        <Button size="small" type="secondary" onClick={onAdd}>
                            {addLabel}
                        </Button>
                    </div>
                    <div className="rates-crud-lines-widget__content">
                        {isEmpty ? (
                            <div className="rates-crud-lines-widget__empty">
                                <Icon name="emptyFile" size="large" />
                                <Text color={theme.colors.utility.textSecondary} type="body">
                                    {emptyText}
                                </Text>
                            </div>
                        ) : (
                            children
                        )}
                    </div>
                </div>
                {footer}
            </div>
        );
    },
);

RatesTableSection.displayName = 'RatesTableSection';

export default RatesTableSection;
